import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class FarmerService {

  route = '/api/farmerentry';

  constructor(private dataService: DataService) {
  };

  get(data: any, refresh: Boolean) {
    return this.dataService.getData('/api/farmerentry/' + data.region + '/' + data.division + '/' + data.subdivision, refresh);
  }

  getsoloFarmer(data: any, refresh: Boolean) {
    return this.dataService.getData('/api/farmerentry/' + data.categoryType + '/' + data.region + '/' + data.division + '/' + data.subdivision, refresh);
  }

  getRSUHours(data: any, refresh: Boolean) {
    return this.dataService.getData('/api/vehiclestatus/status/' + data.vehicleId + '/' + data.gpsDeviceTs, refresh);
  }

  getByfarmerId(id: number) {
    return this.dataService.getRecord('/api/farmerentry/detail/' + id);
  }



  getbyQId(data: any, refresh: Boolean) {
    return this.dataService.getData('/api/farmerentry/logs/' + data.vehicleId, refresh);
  }

  getById(id: number) {
    return this.dataService.getRecord('/api/farmerentry/' + id);
  }

  save(data: any) {
    return this.dataService.post('/api/farmerentry', data).map(response => {
      return response;
    });
  }

  delete(id: number) {
    return this.dataService.delete('/api/farmerentry/' + id).map(response => {
      this.dataService.clearCache();
      this.dataService.clearRouteCache(this.route);
      return response;
    });
  }

  getlastfuelfilledodometer(data: any, refresh: Boolean) {
    return this.dataService.getDataWithParams('/api/farmerentry/lastfuelfilledodometer', data, refresh);
  }
  getFuelProvider(refresh: Boolean) {
    return this.dataService.getData('/api/lookup/fuelprovider', refresh);
  }
  getFuelSourceType(refresh: Boolean) {
    return this.dataService.getData('/api/lookup/fuelsourcetype', refresh);
  }
  getFuelType(refresh: Boolean) {
    return this.dataService.getData('/api/lookup/fueltype', refresh);
  }
  // getspareitemLookup(refresh: Boolean){
  //     return this.dataService.getData('/api/servicelog/spareitemlookup', refresh);
  // }
  getlastfilledfueldetail(id: number, refresh: boolean) {
    return this.dataService.getData('/api/farmerentry/lastfilledfueldetail/' + id, refresh);

  }

  // getFarmerBookingList(refresh: boolean) {
  //     return this.dataService.getData('/api/dbtfarmertarget/getfarmerbookinglist', refresh);

  // }
  getFarmerBookingList(refresh: boolean) {
    return this.dataService.getData('/api/dbtfarmertarget/getfarmerbookinggridlist', refresh);

  }
  getFarmerWaitingBookingList(data: any, refresh: boolean) {
    return this.dataService.getData('/api/dbtfarmertarget/getfarmerwaitingbookinggridlist/' + data.regionId + '/' + data.divisionId + '/' + data.subDivisionId + '/' + data.financialYearId, refresh);
  }
  getFarmerBookingListByVillageId(id: any, deptId: any, refresh: boolean, financialYearId: any) {
    return this.dataService.getData('/api/dbtfarmertarget/getfarmerbookinglist/' + id + '/' + deptId + '/' + financialYearId, refresh);
  }

  getBookingList(form) {
    return this.dataService.getData('/api/phire/bookinglist/' + form.regionid + '/' + form.divisionId + '/' + form.subdivisionId + '/' + form.districtId + '/' + form.blockId + '/' + form.projectId + '/' + form.financialYearId, true);
  }

  farmerSave(result: any) {
    return this.dataService.post('/api/dbtfarmertarget/farmerbookingsave', result).map(res => {
      this.dataService.clearRouteCache(this.route);
      return res;
    }
    );
  }
  getbankcity(id: any, refresh: boolean) {
    return this.dataService.getData('/api/bank/citylist/' + id, refresh)
  }
  getbranch(id: any, refresh: boolean) {
    return this.dataService.getData('/api/bank/branchlist/' + id, refresh)
  }


  getLookupScehme(refresh: boolean) {
    return this.dataService.getData('/api/dbtstatetarget/dbtallschemelist', refresh)
  }

  getLookupStatus(refresh: boolean) {
    return this.dataService.getData('/api/lookup/eventType', refresh)
  }
  getVerification(refresh: boolean) {
    return this.dataService.getData('/api/dbtfarmertarget/verificationlist', refresh)
  }

  farmerInspectionSave(result: any) {
    return this.dataService.post('/api/farmerbookingsubsidy/farmersubsidysave', result).map(res => {
      this.dataService.clearRouteCache(this.route);
      return res;
    }
    );
  }
  getdeliveryDelayType(refresh: boolean) {
    return this.dataService.getData('/api/lookup/deliveryDelayType', refresh)
  }
  getfarmertypeLookup(refresh: boolean) {
    return this.dataService.getData('/api/lookup/farmerType', refresh)
  }
  getRejectionlist(refresh: boolean) {
    return this.dataService.getData('/api/lookup/rejectionType', refresh)
  }
  getInspectionReport(dbtBookingId: any, type: any, refresh: boolean) {
    return this.dataService.getData('/api/dbtfarmertarget/inspectionReport/' + dbtBookingId + '/' + type, refresh)
  }
  getWorkOrderReceiptByRefNo(bookingRefNo: string) {
    return this.dataService.post('/api/dbtfarmertarget/workorderreceipt', { bookingRefNo: bookingRefNo });
  }
  getblockvillagemapping(regionId: number, divisionId: number, subDivisionId: number, blockId: number, villageId: number, refresh: boolean) {
    return this.dataService.getData('/api/subdivision/blockvillagemapping/' + regionId + '/' + divisionId + '/' + subDivisionId + '/' + blockId + '/' + villageId, refresh)
  }
  getfarmerbookinggridbyidlist(id: number, refresh: boolean) {
    return this.dataService.getData('/api/dbtfarmertarget/getfarmerbookinggridbyidlist/' + id, refresh);
  }
  getPaccsList(districtId, blockId, villageId, gramPanchayatId, productId, componentId, refresh) {
    return this.dataService.getData('/api/paccsbooking/' + districtId + '/' + blockId + '/' + villageId + '/' + gramPanchayatId + '/' + productId + '/' + componentId, refresh);
  }
  getpaccsbookingList(regionId: number, divisionId: number, subDivisionId: number, refresh: boolean) {
    return this.dataService.getData('/api/paccsbooking/' + regionId + '/' + divisionId + '/' + subDivisionId, refresh);
  }
  getfarmergridalldata(data: any) {
    return this.dataService.post('/api/dbtfarmertarget/getfarmerbookingAllgridlist', data);
  }
  getfarmergridallsearchdata(data: any) {
    return this.dataService.post('/api/dbtfarmertarget/GetFarmerBookingGridAllListSearch', data);
  }

  getPvtMachineList(form) {
    return this.dataService.getData('/api/pvtvehicle/' + form.regionid + '/' + form.divisionId + '/' + form.subdivisionId + '/' + form.blockId, true)
  }

  GetSinglevehicle(id: any) {
    return this.dataService.getData('/api/pvtvehicle/' + id, true);
  }

  verify(data) {
    return this.dataService.post('/api/pvtvehicle/aevehicleevent', data)
  }

  approveOrReject(data) {
    return this.dataService.post('/api/pvtvehicle/aeevehicleevent', data)
  }

  getPvtImplementList(form) {
    return this.dataService.getData('/api/pvtimplement/' + form.regionid + '/' + form.divisionId + '/' + form.subdivisionId + '/' + form.blockId, true)
  }

  GetSingleImplement(id: any) {
    return this.dataService.getData('/api/pvtimplement/' + id, true);
  }

  verifyImplement(data) {
    return this.dataService.post('/api/pvtimplement/aepvtimplementevent', data)
  }

  approveOrRejectImplement(data) {
    return this.dataService.post('/api/pvtimplement/aeepvtimplementevent', data)
  }

  getTimelineDetailsforImplement(implenetId: any) {
    return this.dataService.getData('/api/pvtimplement/implementevent/' + implenetId, true)
  }

  getTimelineDetailsforMachine(vehicleId: any) {
    return this.dataService.getData('/api/pvtvehicle/vehicleevent/' + vehicleId, true)
  }

  GetVehicleByUser(id: any) {
    return this.dataService.getData('/api/pvtvehicle/vehiclebyuser/' + id, true);
  }

  GetImplementByUser(id: any) {
    return this.dataService.getData('/api/pvtimplement/implementbyuser/' + id, true);
  }
  paccsServiceProviderApprove(data: any) {
    return this.dataService.post('/api/user/paccsapprove', data)
  }
  paccsMarkAsDuplicate(paccsId: any) {
    return this.dataService.post('/api/user/paccsmarkasduplicate/' + paccsId, {})
  }
  GetInformationByUser(id: any) {
    return this.dataService.getData('/api/user/information/' + id, true);
  }
  setIsigned(data: any) {
    return this.dataService.post('/api/user/aeeesign', data);
  }
  updateesign(data: any) {
    return this.dataService.post('/api/user/aeeesignupdate', data);
  }
  downloadPhireReceiptdownload(data: any) {
    return this.dataService.post('/api/report/PhireReceiptdownload', data)
  }

  generateXml(data: any) {
    return this.dataService.post('/api/esign/generatexml', data).map(res => {
      return res;
    })
  }

  GetInformationforDriver(id: any) {
    return this.dataService.getData('/api/serviceprovider/driverlist/' + id, true);
  }
  GetfullInformationforDriver(id: any) {
    return this.dataService.getData('/api/serviceprovider/driverinfo/' + id, true);
  }
  GetInformationforTariff(id: any) {
    return this.dataService.getData('/api/serviceprovider/tarifflist/' + id, true);
  }
  verifyOrNot(data) {
    return this.dataService.post('/api/farmeraccountdetail/accountverify', data)
  }
  verifyStatus(data) {
    return this.dataService.post('/api/e2e/updatefarmerstatus', data)
  }

  getFarmerBookingListByYear(data: any, refresh: boolean) {
    return this.dataService.getData('/api/dbtfarmertarget/getfarmerbookinggridlistdata/' + data.regionId + '/' + data.divisionId + '/' + data.subdivisionId + '/' + data.districtId + '/' + data.blockId + '/' + data.financialYearId, refresh);
  }
}
